import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useStoryStore = create(
  persist(
    (set, get) => ({
      stories: [],
      currentStory: null,

      createStory: (title, description) => {
        const newStory = {
          id: Date.now().toString(),
          title,
          description,
          status: 'draft',
          shareId: Math.random().toString(36).substring(2, 15),
          nodes: [
            {
              id: 'start',
              type: 'start',
              position: { x: 250, y: 50 },
              data: { label: 'Start' }
            }
          ],
          edges: [],
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        };

        set(state => ({
          stories: [...state.stories, newStory]
        }));

        return newStory;
      },

      updateStory: (storyId, updates) => {
        set(state => ({
          stories: state.stories.map(story =>
            story.id === storyId
              ? { ...story, ...updates, updatedAt: new Date().toISOString() }
              : story
          )
        }));
      },

      deleteStory: (storyId) => {
        set(state => ({
          stories: state.stories.filter(story => story.id !== storyId)
        }));
      },

      duplicateStory: (storyId) => {
        const story = get().stories.find(s => s.id === storyId);
        if (story) {
          const duplicatedStory = {
            ...story,
            id: Date.now().toString(),
            title: `${story.title} (Copy)`,
            shareId: Math.random().toString(36).substring(2, 15),
            status: 'draft',
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
          };

          set(state => ({
            stories: [...state.stories, duplicatedStory]
          }));

          return duplicatedStory;
        }
      },

      getStoryByShareId: (shareId) => {
        return get().stories.find(story => story.shareId === shareId && story.status === 'published');
      },

      setCurrentStory: (story) => {
        set({ currentStory: story });
      },

      updateStoryNodes: (storyId, nodes, edges) => {
        set(state => ({
          stories: state.stories.map(story =>
            story.id === storyId
              ? { 
                  ...story, 
                  nodes, 
                  edges, 
                  updatedAt: new Date().toISOString() 
                }
              : story
          )
        }));
      }
    }),
    {
      name: 'story-storage',
    }
  )
);

export { useStoryStore };